import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { zxModules } from '@/mocks/zhongxian-commerce';

export default function ModuleExplorer() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="功能模块"
          subtitle="六大经营模块覆盖市场经营、商户经营、食安溯源、消费激励、全渠道履约与合规安全。"
        />

        <div className="mt-12 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {zxModules.map((m, idx) => (
            <Reveal key={m.key} delay={Math.min(idx * 60, 360)}>
              <div className="h-full flex items-center gap-4 p-6 rounded-lg bg-background-50 border border-background-200 transition-colors hover:border-primary-300">
                <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${m.icon} text-xl`}></i>
                </span>
                <div className="min-w-0">
                  <span className="text-[11px] font-semibold tracking-widest text-foreground-400">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug">{m.name}</h3>
                  <p className="mt-1 text-xs md:text-sm text-foreground-500">{m.alias}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}